import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { InsightsCard } from './insights-card';

export function Insights({ content = DEFAULT_CONTENT, pageUrl = '' }) {
  return (
    <section className="insights pt-2 pb-3">
      <Container>
        <h2 className="heading-3">{content.metadata('title').value()}</h2>
        <Row className="mt-1_5">
          {content.children().map((entry, ind) => (
            <Col xs={12} md={4} key={entry.id} className="mb-1">
              <InsightsCard
                contentStr={entry.content}
                imageUrl={entry.metadata('image').value('')}
                pageUrl={pageUrl}
                isYellow={ind === 0}
                isBlue={ind === content.children().length - 1}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

Insights.propTypes = {
  content: CmsEntities.Content,
  pageUrl: PropTypes.string,
};
